import {TypedShapeCommand} from '../commands.template';
import {IResourceJson} from '../../diagram-data/diagram-json-handler.service';
import * as _ from 'lodash';
import {isExtended} from '../../diagram-render/helpers/shapes-detectors.util';

export class ResourceChangeRasciCommand extends TypedShapeCommand<IResourceJson> {
  protected services: any;
  private rasci: any;
  private oldRasci: any;

  constructor(data, newRasci) {
    super(data);
    this.oldRasci = _.cloneDeep(data.rasci);
    this.rasci = _.cloneDeep(newRasci);
  }

  public execute() {
    super.execute();
    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        rasci: this.rasci
      }
    });

    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);

    if (isExtended(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }

  public reverse() {
    super.reverse();
    this.services.diagramUpdateSvc.update({
      changeResource: {
        activityMxKey: this.object.activityMxKey,
        mxKey: this.object.mxKey,
        rasci: this.oldRasci
      }
    });

    const model = this.services.registry.getGraph().getModel();
    const cell = model.getCell(this.object.activityMxKey);

    if (isExtended(cell)) {
      cell.comp.instance.setupFromJson();
    }
  }
}
